import React, { useContext } from 'react'
import I18n from 'i18n'
import { useLocation } from 'react-router-dom'
import { SessionContext } from '../session/SessionProvider'
import Routes from '../common/Routes'
import MfaEnrolmentNotice from './layout/MfaEnrolmentNotice'
import { needsMfaEnrolment } from './MfaEnrolment'

const MfaEnrolmentBanner = () => {
  const { myProfile } = useContext(SessionContext)
  const { pathname } = useLocation()
  if (!needsMfaEnrolment(myProfile) || pathname.startsWith(Routes.admin.index)) return <></>

  return (
    <div className='container'>
      <MfaEnrolmentNotice
        title={I18n.t('components.2fa.enrolment.banner.title')}
        description={I18n.t('components.2fa.enrolment.banner.description')}
        className='mfa-enrolment-notice--global'
        testId='mfa-enrolment-banner'
      />
    </div>
  )
}

export default MfaEnrolmentBanner
